<style scoped>
.products {
    background-color: #51423A;
}

.product-image {
    width: 100%;
}
</style>
<template>
    <div class="products">
        <div class="container">
      




        </div>
        <div>
            
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'

</script>

